import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MasterDataService } from '../../services/master-data.service';
import { HumanResourceService } from '../../services/human-resource.service';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-budget-vs-actual-cost-report',
  templateUrl: './budget-vs-actual-cost-report.component.html',
  styleUrls: ['./budget-vs-actual-cost-report.component.css']
})
export class BudgetVsActualCostReportComponent implements OnInit {
  financialList;
  selectedFinancialYear;
  forFYBudgetVSActualCostList=[];
  forPartnerBudgetVSActualCostList=[];
  forFYBudgetVSActualCostByRoleList=[];
  forClientBudgetVSActualCostList=[];
  forAssignmentBudgetVSActualCostList=[];
  partnerList;
  selectPartner;
  selectClient=[];
  clientList;
  isClientSelected=false;
  selectAssignment=[];
  assignmentList;
  isAssignmentSelected=false;
  selectManDays=0;


  // view :any= [1000, 600];
  fitContainer: boolean = false;
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  legentPosition="below";
  showGridLines=false;
  showXAxisLabel = true;
  xAxisLabelForFY = "Year";
  xAxisLabelForFYRole="Role";
  xAxisLabelForClient="Client";
  xAxisLabelForPartner="Partner";
  xAxisLabelForAssignmnet="Assignment";
  showYAxisLabel = true;
  yAxisLabel = 'Cost (Rs)';
  timeline = true;
  doughnut = true;
  showDataLabel=true;
  colorScheme = {
    domain: ['#800000','#fa7a7a']
  };
  showLegendForRole=true;
  routeName;
  checkMyVaianceReport;

 constructor(private masterDataService:MasterDataService,
  private humanResourceService:HumanResourceService,
  private commonMessageService:CommonMessageService,
  private activatedRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.routeName=this.activatedRoute.snapshot.routeConfig.path;
    if(this.routeName=='my-budget-vs-actual-cost'){
      this.checkMyVaianceReport=true;
      this.selectManDays=1;
    }else{
      this.checkMyVaianceReport=false;
      this.selectManDays=0;
    }
    console.log('router name',this.routeName);
    this.selectedFinancialYear="";
    this.selectPartner="";
    this.loadFYDetails();
  }

  loadFYDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onFinancialYearSelected(){
    this.selectPartner="";
    this.selectClient=[];
    this.selectAssignment=[];
    console.log('financial year value',this.selectedFinancialYear);
    if(this.selectedFinancialYear!=undefined && this.selectedFinancialYear!=""){
      this.getAllPartnerDetails();
    }
  }

  partnerArrayList=[];
  getAllPartnerDetails(){
    if(this.routeName=='my-budget-vs-actual-cost'){
      if(JSON.parse(localStorage.getItem("partnerArray")).length == 0) {
        var partnerObj = {
          "id": null,
          "reportingPartner": {
            "id": localStorage.getItem('id'),
            "userId": "",
            "firstName":localStorage.getItem('userFname'),
            "middleName": "",
            "lastName": localStorage.getItem('userLname'),
            "email": ""
          },
          "startDate": "",
          "endDate": ""
        }
    
        this.partnerArrayList.push(partnerObj);
        console.log('partner list', this.partnerArrayList);
      }else{
        this.partnerArrayList = JSON.parse(localStorage.getItem("partnerArray"));
      }
    
    }else{
    this.masterDataService.getAllBudgetedPartner(this.selectedFinancialYear.id).subscribe((res:any)=>{
      console.log('partner res',res);
        this.partnerList = res;
    })
   }
  }

   partnerId;
   onPartnerSelected(){
    this.selectClient=[];
    this.selectAssignment=[];
    if(this.selectPartner!=undefined && this.selectPartner!=""){
    if(this.routeName=='my-budget-vs-actual-cost'){
     this.partnerId=this.selectPartner.reportingPartner.id;
    }else{
      this.partnerId=this.selectPartner.id;
    }
    this.getAllClientDetails();
    }
   }

  getAllClientDetails(){
  this.masterDataService.getAllClientByYear(this.selectedFinancialYear.id, this.partnerId).subscribe((resp:any)=>{
    console.log('client list',resp);
    this.clientList=resp;
  })
  }

  getAllAssignmentDetails(){
    this.selectAssignment=[];
    if(this.selectClient.length>0 && this.selectedFinancialYear!=""){
    const clientId = this.selectClient.map(({ id }) => id);
    this.masterDataService.getAllAssignment(this.selectedFinancialYear.id,clientId, this.partnerId).subscribe((resp:any)=>{
      console.log('Assignment List',resp);
      this.assignmentList=resp;
    });
  }
  }

  selectAllClient(select: NgModel, values) {
    console.log('inside select client method',this.selectAssignment);
    this.selectAll(select, values, this.isClientSelected);
    this.isClientSelected = !this.isClientSelected;
    this.getAllAssignmentDetails();
  }

  selectAllAssignment(select: NgModel, values){
    this.selectAll(select, values, this.isAssignmentSelected);
    this.isAssignmentSelected = !this.isAssignmentSelected;
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  showFYData:boolean;
  showPartnerData:boolean;
  showFYRoleData:boolean;
  showClientData:boolean;
  showAssignmentData:boolean;
  showManDaysAfterViewReport:boolean;
  onViewReport(){
    if(this.selectManDays==0){
    this.showManDaysAfterViewReport=true;
    this.yAxisLabel='Cost (Rs)';
    }else{
    this.showManDaysAfterViewReport=false;
    this.yAxisLabel='Man Days';
    }

    this.showFYData=false;
    this.showPartnerData=false;
    this.showFYRoleData=false;
    this.showClientData=false;
    this.showAssignmentData=false;

    this.forFYBudgetVSActualCostList=[];
    this.forClientBudgetVSActualCostList=[];
    this.forAssignmentBudgetVSActualCostList=[];
    this.forPartnerBudgetVSActualCostList=[];

    console.log('getBudgetVSActualCostForFYByRole',this.selectClient.length,this.selectAssignment.length);
    var clientId = this.selectClient.map(({ id }) => id);
    var assignmentId=this.selectAssignment.map(({id})=>id);

    console.log('year',this.selectedFinancialYear,this.selectClient);
    if(this.selectedFinancialYear=="" || this.selectedFinancialYear==undefined && this.selectClient.length==0 ){
      this.commonMessageService.swalAlertWithoutIcon('',"Please Select Financial Year");
      return;
    }
    if(this.selectClient.length>0 && this.selectAssignment.length==0 ){
      this.selectAssignment=[];
      this.masterDataService.getBudgetVSActualCostForClient(this.selectedFinancialYear.id,clientId,this.partnerId,this.selectManDays).subscribe((resp:any)=>{
        console.log('for client resp',resp);
        this.forClientBudgetVSActualCostList=resp.multi;
        this.showClientData=true;
        this.showFYData=false;
        this.showPartnerData=false;
        this.showFYRoleData=false;
        this.showAssignmentData=false;
        this.selectAssignment=[];
      });
    }else if(this.selectClient.length>0 && this.selectAssignment.length>0){
    this.masterDataService.getBudgetVSActualCostForAssignment(this.selectedFinancialYear.id,clientId,assignmentId,this.partnerId,this.selectManDays).subscribe((resp:any)=>{
      console.log('for assignment resp',resp);
      this.forAssignmentBudgetVSActualCostList=resp.multi;
      this.showAssignmentData=true;
      this.showClientData=false;
      this.showFYData=false;
      this.showPartnerData=false;
      this.showFYRoleData=false;
    });
    }else if(this.selectPartner!="" && this.selectAssignment.length==0 && this.selectClient.length==0){
      console.log('inside partner if',this.selectPartner);
      this.masterDataService.getBudgetVSActualCostForPartner(this.selectedFinancialYear.id,this.partnerId,this.selectManDays).subscribe((resp:any)=>{
      console.log('partner resp',resp);
      this.forPartnerBudgetVSActualCostList=resp;
      this.showPartnerData=true;
      this.showAssignmentData=false;
      this.showClientData=false;
      this.showFYData=false;
      this.showFYRoleData=false;
      });
    }else{
      this.selectPartner="";
      this.selectClient=[];
      this.selectAssignment=[];
      this.masterDataService.getBudgetVSActualCostForFY(this.selectedFinancialYear.id,this.selectManDays).subscribe((resp:any)=>{
        console.log('for year resp',resp);
        this.forFYBudgetVSActualCostList=resp;
        this.showFYData=true;
        this.showPartnerData=false;
        this.showFYRoleData=false;
        this.showClientData=false;
        this.showAssignmentData=false;
        this.selectClient=[];
        this.selectAssignment=[];
      });
    }
  }

  onSelectFYCost(event){
    var clientId=0;
    var assignmentId=0;
    var partnerId=0;
    this.viewFYBudgetVSActualCostByDesignationDetails(clientId,assignmentId,partnerId);
  }

  onSelectPartnerCost(event){
    var clientId=0;
    var assignmentId=0;
    this.viewFYBudgetVSActualCostByDesignationDetails(clientId,assignmentId,this.partnerId);
  }

  onSelectForClient(event){
    var clientId;
    this.forClientBudgetVSActualCostList.map((item)=>{
      if(item.name==event.series){
       clientId=item.id;
      }});
    var assignmentId=0;
    this.viewFYBudgetVSActualCostByDesignationDetails(clientId,assignmentId,this.partnerId);
  }

  onSelectForAssignment(event){
    console.log('assignment',event);
    var assignmentId;
    this.forAssignmentBudgetVSActualCostList.map((item)=>{
      if(item.name==event.series){
        assignmentId=item.id;
      }});
    var clientId = this.selectClient.map(({ id }) => id);
    console.log('client id',clientId);
    this.viewFYBudgetVSActualCostByDesignationDetails(clientId,assignmentId,this.partnerId);
  }


  viewFYBudgetVSActualCostByDesignationDetails(clientId,assignmentId,partnerId){
    this.masterDataService.getBudgetVSActualCostForFYByDesignation(this.selectedFinancialYear.id,clientId,assignmentId,partnerId,this.selectManDays).subscribe((resp:any)=>{
      console.log('for year wise role resp',resp);
      this.forFYBudgetVSActualCostByRoleList=resp.multi;
      this.showFYRoleData=true;
      this.showFYData=false;
      this.showPartnerData=false;
      this.showClientData=false;
      this.showAssignmentData=false;
    });
  }

  goBack(){
    console.log('for fy',this.forFYBudgetVSActualCostList);
    console.log('for client',this.forClientBudgetVSActualCostList);
    console.log('for assignment',this.forAssignmentBudgetVSActualCostList);
    this.showFYRoleData=false;
    if(this.forFYBudgetVSActualCostList.length>0){
    this.showFYData=true;
    }
    if(this.forPartnerBudgetVSActualCostList.length>0){
      this.showPartnerData=true;
    }

    if(this.forClientBudgetVSActualCostList.length>0){
    this.showClientData=true;
    }
    if(this.forAssignmentBudgetVSActualCostList.length>0){
    this.showAssignmentData=true;
    }
  }
}
